import { Loading, ErrorMessage, SimpleButton } from '@/src/ui';

export function renderLoaders(
    loading: boolean,
    success: boolean,
    error: string | null,
    isEdit: boolean
) {
    return (
        <>
            {loading && (
                <Loading
                    message={isEdit ? 'Updating question...' : 'Creating question...'}
                    size="md"
                />
            )}
            {error && <ErrorMessage error={error} />}
            {success && (
                <div className="fixed inset-0 flex items-center justify-center z-110 bg-[#00000040]">
                    <div className="bg-white rounded shadow-lg p-6 flex flex-col items-center">
                        <div className="text-green-700 font-bold text-lg mb-2">
                            {isEdit ? 'Question updated!' : 'Question created!'}
                        </div>
                        <SimpleButton
                            type="button"
                            className="mt-2 px-4 py-2 bg-blue-600 text-white rounded"
                            onClick={() => (window.location.href = '/questions/viewQuestions')}
                        >
                            OK
                        </SimpleButton>
                    </div>
                </div>
            )}
        </>
    );
}
